import React from 'react';
import { pageData } from './data';
export function Footer() {
  const {
    footer
  } = pageData;
  return <footer className="bg-navy-950 py-12 px-4 border-t border-white/5" data-id="element-69">
      <div className="max-w-5xl mx-auto text-center" data-id="element-70">
        <div className="text-slate-500 text-sm mb-6" data-id="element-71">{footer.copyright}</div>

        <p className="text-slate-600 text-xs max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-72">
          {footer.disclaimer}
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-73">
          {footer.links.map((link, idx) => <a key={idx} href={link.href} className="text-slate-400 hover:text-white transition-colors" data-id="element-74">
              {link.label}
            </a>)}
        </div>
      </div>
    </footer>;
}